export default __webpack_public_path__ + "pGGbv.png?04ec1d9eff120cb57a3845bbbe6e7d42";